/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standings_EmptyInputs */

const th_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีทีมลงทะเบียน`)
};

const en_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams registered yet.`)
};

const ja_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録されたチームはまだありません。`)
};

const zh_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚无球队报名。`)
};

const es_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay equipos inscritos.`)
};

const pt_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum time inscrito ainda.`)
};

const id_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada tim yang mendaftar.`)
};

const fr_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune équipe inscrite pour l’instant.`)
};

const tl_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang team na sumali.`)
};

const vi_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đội nào đăng ký.`)
};

const ko_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 등록한 팀이 없습니다.`)
};

const de_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Teams gemeldet.`)
};

const ru_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни одна команда ещё не заявилась.`)
};

const tr_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz kaydolan takım yok.`)
};

const it_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna squadra iscritta.`)
};

const pl_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zgłosiła się jeszcze żadna drużyna.`)
};

const uk_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жодна команда ще не заявилася.`)
};

const hi_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी किसी टीम ने पंजीकरण नहीं कराया।`)
};

const ar_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يسجّل أي فريق بعد.`)
};

const ms_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pasukan mendaftar.`)
};

const bn_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও দল নিবন্ধন করেনি।`)
};

const zh_tw2_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無球隊報名。`)
};

const zh_hk2_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無球隊報名。`)
};

const ur_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کسی ٹیم نے رجسٹر نہیں کیا۔`)
};

const fa_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز تیمی ثبت‌نام نکرده است.`)
};

const sw_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna timu iliyojisajili bado.`)
};

const nl_standings_empty = /** @type {(inputs: Standings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen teams ingeschreven.`)
};

/**
* | output |
* | --- |
* | "No teams registered yet." |
*
* @param {Standings_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const standings_empty = /** @type {((inputs?: Standings_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standings_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_standings_empty(inputs)
	if (locale === "ja") return ja_standings_empty(inputs)
	if (locale === "zh") return zh_standings_empty(inputs)
	if (locale === "es") return es_standings_empty(inputs)
	if (locale === "pt") return pt_standings_empty(inputs)
	if (locale === "id") return id_standings_empty(inputs)
	if (locale === "fr") return fr_standings_empty(inputs)
	if (locale === "tl") return tl_standings_empty(inputs)
	if (locale === "vi") return vi_standings_empty(inputs)
	if (locale === "ko") return ko_standings_empty(inputs)
	if (locale === "de") return de_standings_empty(inputs)
	if (locale === "ru") return ru_standings_empty(inputs)
	if (locale === "tr") return tr_standings_empty(inputs)
	if (locale === "it") return it_standings_empty(inputs)
	if (locale === "pl") return pl_standings_empty(inputs)
	if (locale === "uk") return uk_standings_empty(inputs)
	if (locale === "hi") return hi_standings_empty(inputs)
	if (locale === "ar") return ar_standings_empty(inputs)
	if (locale === "ms") return ms_standings_empty(inputs)
	if (locale === "bn") return bn_standings_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_standings_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_standings_empty(inputs)
	if (locale === "ur") return ur_standings_empty(inputs)
	if (locale === "fa") return fa_standings_empty(inputs)
	if (locale === "sw") return sw_standings_empty(inputs)
	if (locale === "nl") return nl_standings_empty(inputs)
	return en_standings_empty(inputs)
});